import React from 'react';
import { Stepper, Step } from "@salt-ds/core";
import "../../pages/CommonCard.css"
function StepTracker(props) {
  return (
    <Stepper>
      <Step label={props.label1} stage={props.step1} className="steptrackertext"/>
      <Step label={props.label2} stage={props.step2} />
      <Step label={props.label3} stage={props.step3} />
    </Stepper>
  );
}

export default StepTracker;